<template>
  <div class="workbench-content" v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(255, 255, 255, 0.3)">
    <div class="header-row">
      <div class="page-title">
        <img :src="iconImg" class="title-icon" />
        <span class="main-title">上市清单</span>
        <div class="title-decoration">
          <img :src="titleImg" class="title-decoration-img" />
        </div>
      </div>
      <div class="date-picker-wrapper">
        <span class="date-label">预计上线时间：</span>
        <el-date-picker
          v-model="searchForm.date"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          size="mini"
          class="custom-date-picker"
          :clearable="false"
        >
        </el-date-picker>
        <i class="el-icon-date date-icon-suffix"></i>
      </div>
    </div>

    <div class="main-area">
      <div class="left-stats">
        <div class="stats-row" v-for="(row, rowIndex) in statsRows" :key="rowIndex" @click="handleCardClick(row)">
          <div class="stat-item main-stat">
            <div class="stat-value" :class="row[0].colorClass">{{ row[0].value }}</div>
            <div class="stat-label">{{ row[0].label }}</div>
          </div>

          <div class="stat-item">
            <div class="stat-value" :class="row[1].colorClass">{{ row[1].value }}</div>
            <div class="stat-label">{{ row[1].label }}</div>
          </div>

          <div class="divider"></div>

          <div class="stat-item" v-for="(item, index) in row.slice(2)" :key="index">
            <div class="stat-value" :class="item.colorClass">{{ item.value }}</div>
            <div class="stat-label">{{ item.label }}</div>
          </div>
        </div>
      </div>

      <div class="right-gauges">
        <div class="gauge-item" v-for="(gauge, index) in gauges" :key="index">
          <div class="gauge-header">
            <span>{{ gauge.title }}</span>
            <el-tooltip :content="gauge.tooltip" placement="top">
              <i class="el-icon-question help-icon"></i>
            </el-tooltip>
          </div>

          <div class="gauge-chart-container">
            <div class="gauge-circle">
              <img :src="numberImg" class="gauge-bg-img" />
              <div class="gauge-value">{{ gauge.value }}</div>
            </div>
            <div class="gauge-footer">平均耗时统计(天)</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import headerBoxImg from '@/assets/images/workbench_img/headerBox.png';
import numberImg from '@/assets/images/workbench_img/number.png';
import titleImg from '@/assets/images/workbench_img/title.png';
import iconImg from '@/assets/images/workbench_img/icon.png';

export default {
  name: 'LaunchList',
  data() {
    return {
      searchForm: {
        date: [moment().subtract(6, 'months').format('YYYY-MM-DD'), moment().add(3, 'months').format('YYYY-MM-DD')],
      },
      headerBoxImg,
      numberImg,
      titleImg,
      iconImg,
      statsRows: [
        [
          { value: 0, label: '待发布清单总计', colorClass: 'text-yellow' },
          { value: 0, label: '待发布总商品数', colorClass: 'text-yellow' },
          { value: 0, label: '基础信息 未完成商品数', colorClass: 'text-yellow' },
          { value: 0, label: '产品文案 未完成商品数', colorClass: 'text-yellow' },
          { value: 0, label: '产品价格 未完成商品数', colorClass: 'text-yellow' },
        ],
        [
          { value: 0, label: '延期待发布清单', colorClass: 'text-orange' },
          { value: 0, label: '待发布总商品数', colorClass: 'text-orange' },
          { value: 0, label: '基础信息 未完成商品数', colorClass: 'text-orange' },
          { value: 0, label: '产品文案 未完成商品数', colorClass: 'text-orange' },
          { value: 0, label: '产品价格 未完成商品数', colorClass: 'text-orange' },
        ],
        [
          { value: 0, label: '正常待发布清单', colorClass: 'text-blue' },
          { value: 0, label: '待发布总商品数', colorClass: 'text-blue' },
          { value: 0, label: '基础信息 未完成商品数', colorClass: 'text-blue' },
          { value: 0, label: '产品文案 未完成商品数', colorClass: 'text-blue' },
          { value: 0, label: '产品价格 未完成商品数', colorClass: 'text-blue' },
        ],
      ],
      gauges: [
        { title: '基础信息', value: 0, tooltip: '汇总相加各商品的（基础信息完成时间 – 清单创建时间） /  商品数；' },
        { title: '产品文案', value: 0, tooltip: '汇总相加各商品的（产品文案完成时间 – 基础信息完成时间） /  商品数；' },
        { title: '产品价格', value: 0, tooltip: '汇总相加各商品的（商品价格完成时间 – 清单创建时间） /  商品数；' },
      ],
      loading: false,
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.loading = true;
      await this.newProductListStatistics(0);
      await this.newProductListStatistics(1);
      await this.newProductListStatistics(2);
      await this.getListDelayDays();
      this.loading = false;
    },
    newProductListStatistics(index) {
      let params = {
        params: {
          type: index + 1,
        },
      };
      return this.$q.dataBoard.newProductListStatistics(params).then((res) => {
        this.statsRows[index][0].value = res.data.totalQty || 0;
        this.statsRows[index][1].value = res.data.goodsQty || 0;
        this.statsRows[index][2].value = res.data.baseNoFinishQty || 0;
        this.statsRows[index][3].value = res.data.productNoFinishQty || 0;
        this.statsRows[index][4].value = res.data.priceFinishQty || 0;
      });
    },
    getListDelayDays() {
      return this.$q.dataBoard.getListDelayDays().then((res) => {
        this.gauges[0].value = res.data.baseDays || 0;
        this.gauges[1].value = res.data.productDays || 0;
        this.gauges[2].value = res.data.priceDays || 0;
      });
    },
    handleCardClick(row) {
      let status = row[0].label.includes('总计') ? ['未发布', '延期未发布'] : row[0].label.includes('延期') ? ['延期未发布'] : ['未发布'];
      this.$router.push({
        path: '/newProduct/listingList',
        query: {
          status,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.workbench-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: url('../../../../assets/images/workbench_img/content.png') no-repeat center;
  background-size: 100% 100%;
  padding-bottom: 20px
  height: 550px; /* Adjusted height based on screenshot */
  gap: 15px;
  margin-top: 10px;
}

.header-row {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 10px
    border-left: 3px solid #95FEFF
    background: linear-gradient(90deg, rgba(0,60,50,0.5) 0%, rgba(0,0,0,0) 100%);
    margin-bottom: 5px;
}

.page-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 30px;
}

.title-icon {
    height: 20px;
    margin-right: 5px;
}

.main-title {
    font-size: 20px;
    font-family: 'FZLTTH';
    letter-spacing: 1px;
    background: linear-gradient(180deg, #FFFFFF 0%, #B1FFFC 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.title-decoration {
    margin-left: 10px;
    display: flex;
    align-items: center;
}

.title-decoration-img {
    height: 16px;
    opacity: 0.7;
}

.date-picker-wrapper {
    display: flex;
    align-items: center;
    position: relative;
}

.date-label {
    font-size: 14px;
    color: #D4FFFF;
    margin-right: 10px;
    font-family: PingFangSC;
}

.custom-date-picker {
    width: 220px !important;
    background: transparent !important;
    border: 1px solid #0BB78E !important;
    border-radius: 2px !important;
    padding-right: 30px !important;

    >>> .el-range-input {
        background: transparent !important;
        color: #7BFFE0 !important;
        font-size: 12px;
    }
    >>> .el-range-separator {
        color: #7BFFE0 !important;
        line-height: 22px;
    }
    >>> .el-input__icon {
        display: none;
    }
}

.date-icon-suffix {
    position: absolute;
    right: 10px;
    color: #7BFFE0;
    pointer-events: none;
}

.main-area {
    display: flex;
    padding: 0 20px;
    gap: 10px;
    height: 100%;
    overflow: hidden;
}

.left-stats {
    flex: 2;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.stats-row {
    flex: 1;
    background: rgba(5, 72, 56, 0.6);
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    cursor: pointer;
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
}

.stat-item.main-stat {
    flex: 0 0 150px; /* Fixed width for the first column */
}

.stat-value {
    font-family: 'PingFangBold', sans-serif;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
}

.stat-label {
    font-size: 14px;
    color: #fff;
    text-shadow: 1px 2px 4px rgba(3,28,78,0.23);
    font-family: 'AlibabaHuiTi', sans-serif;
}

.text-yellow { color: #FFF6A4; }
.text-orange { color: #F0714B; }
.text-blue { color: #54AFFF; }

.divider {
    width: 1px;
    height: 50px;
    background: #40888A;
    margin: 0 20px;
}

.right-gauges {
    flex: 1;
    display: flex;
    gap: 10px;
}

.gauge-item {
    flex: 1;
    background: rgba(5, 72, 56, 0.6);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    padding: 60px 10px 10px 10px;
}

.gauge-header {
    display: flex;
    justify-content: center;
    font-family: 'AlibabaHuiTi', sans-serif;
    text-shadow: 1px 2px 4px rgba(3,68,78,0.23);
    align-items: center;
    // margin-bottom: 10px;
    color: #fff;
    font-size: 14px;
    gap: 5px;
}

.help-icon {
    font-size: 14px;
    color: rgba(255,255,255,0.5);
    cursor: pointer;
}

.gauge-chart-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

.gauge-circle {
    position: relative;
    width: 140px;
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
}

.gauge-bg-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
    top: 0;
    left: 0;
}

.gauge-value {
    position: relative;
    z-index: 1;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
    font-family: 'PingFangBold', sans-serif;
}

.gauge-footer {
    font-size: 12px;
    color: #fff;
    font-family: 'AlibabaHuiTi', sans-serif;
    background: rgba(40, 253, 255, 0.2);
    padding: 6px 12px;
    border-radius: 12px;
    width: 80%;
    text-align: center
}
</style>
